import React, { FunctionComponent, useState } from 'react'
import { Trans } from 'next-i18next'
import { useCheckoutSizes } from '../../utils/responsive'
import { Link, Text } from '@afterpaytouch/core'
import { ApprovedCreditContractModal } from './ContractModal'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { TransProps } from 'react-i18next'

interface CreditTermsProps {
  documentId?: string
}

export const Terms: FunctionComponent<CreditTermsProps> = ({ documentId }) => {
  const { extraSmallTextSize } = useCheckoutSizes()
  const [showContractModal, setShowContractModal] = useState(false)
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const getTranslation = (): TransProps<string> => {
    const components = {
      contract: (
        <Link
          kind='Underline'
          color='Orca'
          testNameSpace='facility-contract-link'
          onClick={() => {
            logEvent(TrackingEvent.PRESSED_CL_APPROVED_CREDIT_PAGE_CREDIT_CONTRACT_LINK)
            setShowContractModal(true)
          }}
        />
      ),
    }

    return { i18nKey: 'consumerLending:approvedCredit:terms', components }
  }

  const closeContractModal = (): void => {
    setShowContractModal(false)
  }

  return (
    <>
      <Text color='Gray40' size={extraSmallTextSize}>
        <Trans {...getTranslation()} />
      </Text>
      <ApprovedCreditContractModal showContractModal={showContractModal} onClose={closeContractModal} docId={documentId} />
    </>
  )
}
